import React, {useEffect, useRef, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from "@material-ui/core/Grid";
import {withRouter} from "react-router-dom";
import {useStore} from "react-redux";

const useStyles = makeStyles(theme => ({
    root: {
        height: "100%",
        width: "100%",
        margin: "30px 0"
    }
}));

const ReportForm = () => {
    const [url, setUrl] = useState("");
    const appStore = useStore();
    const classes = useStyles();
    const iframeRef = useRef();

    useEffect(() => {
        const {stdYear, userAdmnDiviNo, corprInfoDiviNo} = appStore.getState().user.userInfo;
        setUrl(`https://iit.eyhy.co.kr/kognrTEQ_report.jsp?title=%EC%B6%9C%EB%A0%A5&jrf_folder=tax/fy2021&jrf=k_organizer_TEQ.jrf&arg=std_year,${stdYear},user_admn_divi_no,${userAdmnDiviNo},rept_divi,HC017005,corpr_info_divi_no,${corprInfoDiviNo}`);
    }, []);

    return (
            <Grid container
                  direction="column"
                  alignItems="flex-start"
                  justifyContent="center"
            >
                <div className={classes.root}>
                    <iframe
                        id="reportFrame"
                        ref={iframeRef}
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        scrolling="yes"
                        src={url}
                    />
                </div>
            </Grid>
    );
};

export default withRouter(ReportForm);
